module.exports = __webpack_public_path__ + "assets/images/map-point-pointer.png";